var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgDropdownArrow = function SvgDropdownArrow(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0.867188L4.12445 3.99187C4.20255 4.06998 4.32919 4.06998 4.4073 3.99187L7.53198 0.867188"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDropdownArrow);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgOCA1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMSAwLjg2NzE4OEw0LjEyNDQ1IDMuOTkxODdDNC4yMDI1NSA0LjA2OTk4IDQuMzI5MTkgNC4wNjk5OCA0LjQwNzMgMy45OTE4N0w3LjUzMTk4IDAuODY3MTg4Ii8+Cjwvc3ZnPgo=";